/* import __COLOCATED_TEMPLATE__ from './navigation-container-item.hbs'; */
import Component from '@glimmer/component';

interface Signature {
  Element: HTMLDivElement;

  Args: {
    isComplete: boolean;
    isCurrent: boolean;
    name: string;
  };
}

export default class NavigationContainerItem extends Component<Signature> {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'GiftPaymentPage::NavigationContainerItem': typeof NavigationContainerItem;
  }
}
